import DealerOnlyImage from '../../images/DealerOnly.svg';
import OpenBiddingImage from '../../images/OpenBidding.svg';
import SellThroughImage from '../../images/SellThrough.svg';
import VirtualImage from '../../images/Virtual.svg';

export default function ReasonsToBelieve() {
    return (
        <>
            <section id="reason-to-believe" className="reasonsToBelieve">
                <div className="mdc-layout-grid show-phone-inline-flex">
                    <div className="mdc-layout-grid__inner">
                        <span className="mdc-layout-grid__cell--span-4">
                            <h2>
                                <p className="kmx-typography--display-5 reasonTitle m-b-0">
                                    Nationwide virtual auctions with 60+ locations
                                </p>
                            </h2>
                        </span>
                        <span className="mdc-layout-grid__cell--span-4">
                            <h3 className="kmx-typography--display-3 reasonRightSubtitle">
                                The way auctions should be
                            </h3>
                        </span>
                        <div className="mdc-layout-grid__cell--span-1 reasonImage">
                            <img src={OpenBiddingImage} alt="" />
                        </div>
                        <div className="mdc-layout-grid__cell--span-3 reasonText">
                            <p className="kmx-typography--body-2">Open bidding, no ifs or calls</p>
                        </div>
                        <div className="mdc-layout-grid__cell--span-1 reasonImage">
                            <img src={DealerOnlyImage} alt="" />
                        </div>
                        <div className="mdc-layout-grid__cell--span-3 reasonText">
                            <p className="kmx-typography--body-2">Dealer-only participation</p>
                        </div>
                        <div className="mdc-layout-grid__cell--span-1 reasonImage">
                            <img src={SellThroughImage} alt="" />
                        </div>
                        <div className="mdc-layout-grid__cell--span-3 reasonText">
                            <p className="kmx-typography--body-2">Over 95% sell-thru rate</p>
                        </div>
                        <div className="mdc-layout-grid__cell--span-1 reasonImage">
                            <img src={VirtualImage} alt="" />
                        </div>
                        <div className="mdc-layout-grid__cell--span-3 reasonText">
                            <p className="kmx-typography--body-2">Free to add unlimited buyers</p>
                        </div>
                    </div>
                </div>
                <div className="mdc-layout-grid show-tablet-inline-flex">
                    <div className="mdc-layout-grid__inner">
                        <span className="mdc-layout-grid__cell--span-8">
                            <h2>
                                <p className="kmx-typography--display-5 reasonTitle m-b-0">
                                    Nationwide virtual auctions with 60+ locations
                                </p>
                            </h2>
                        </span>
                        <span className="mdc-layout-grid__cell--span-8">
                            <h3 className="kmx-typography--display-3 reasonRightSubtitle m-0">
                                The way auctions should be
                            </h3>
                        </span>
                        <div className="mdc-layout-grid__cell--span-1 reasonImage">
                            <img src={OpenBiddingImage} alt="" />
                        </div>
                        <div className="mdc-layout-grid__cell--span-2 reasonText">
                            <p className="kmx-typography--body-2">Open bidding, no ifs or calls</p>
                        </div>
                        <div className="mdc-layout-grid__cell--span-1" />
                        <div className="mdc-layout-grid__cell--span-1 reasonImage">
                            <img src={SellThroughImage} alt="" />
                        </div>
                        <div className="mdc-layout-grid__cell--span-2 reasonText">
                            <p className="kmx-typography--body-2">Over 97% sell-thru rate</p>
                        </div>
                        <div className="mdc-layout-grid__cell--span-1" />
                        <div className="mdc-layout-grid__cell--span-1 reasonImage">
                            <img src={DealerOnlyImage} alt="" />
                        </div>
                        <div className="mdc-layout-grid__cell--span-2 reasonText">
                            <p className="kmx-typography--body-2">Dealer-only participation</p>
                        </div>
                        <div className="mdc-layout-grid__cell--span-1" />
                        <div className="mdc-layout-grid__cell--span-1 reasonImage">
                            <img src={VirtualImage} alt="" />
                        </div>
                        <div className="mdc-layout-grid__cell--span-2 reasonText">
                            <p className="kmx-typography--body-2">Free to add unlimited buyers</p>
                        </div>
                        <div className="mdc-layout-grid__cell--span-1" />
                    </div>
                </div>
                <div className="mdc-layout-grid show-desktop-flex desktop-wrapper">
                    <div className="mdc-layout-grid__inner">
                        <div className="mdc-layout-grid__cell--span-1" />
                        <span className="mdc-layout-grid__cell--span-5">
                            <h2>
                                <p className="kmx-typography--display-5 reasonTitle m-b-0">
                                    Nationwide virtual auctions with 60+ locations
                                </p>
                            </h2>
                        </span>
                        <div className="mdc-layout-grid__cell--span-5">
                            <div className="mdc-layout-grid__inner">
                                <span className="mdc-layout-grid__cell--span-12">
                                    <h3 className="kmx-typography--display-3 reasonRightSubtitle m-b-0">
                                        The way auctions should be
                                    </h3>
                                </span>
                                <div className="mdc-layout-grid__cell--span-2 reasonImage">
                                    <img src={OpenBiddingImage} alt="" />
                                </div>
                                <div className="mdc-layout-grid__cell--span-3 reasonText">
                                    <p className="kmx-typography--body-2">
                                        Open bidding, no ifs or calls
                                    </p>
                                </div>
                                <div className="mdc-layout-grid__cell--span-1" />
                                <div className="mdc-layout-grid__cell--span-2 reasonImage">
                                    <img src={SellThroughImage} alt="" />
                                </div>
                                <div className="mdc-layout-grid__cell--span-3 reasonText">
                                    <p className="kmx-typography--body-2">
                                        Over 95% sell-thru rate
                                    </p>
                                </div>
                                <div className="mdc-layout-grid__cell--span-1" />
                                <div className="mdc-layout-grid__cell--span-2 reasonImage">
                                    <img src={DealerOnlyImage} alt="" />
                                </div>
                                <div className="mdc-layout-grid__cell--span-3 reasonText">
                                    <p className="kmx-typography--body-2">
                                        Dealer-only participation
                                    </p>
                                </div>
                                <div className="mdc-layout-grid__cell--span-1" />
                                <div className="mdc-layout-grid__cell--span-2 reasonImage">
                                    <img src={VirtualImage} alt="" />
                                </div>
                                <div className="mdc-layout-grid__cell--span-3 reasonText">
                                    <p className="kmx-typography--body-2">
                                        Free to add unlimited buyers
                                    </p>
                                </div>
                                <div className="mdc-layout-grid__cell--span-1" />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}
